// const window = require('global/window');
// eslint-disable-next-line import/no-extraneous-dependencies,import/no-unresolved
const FileZipIcon = require('@digital-hig/icon/lib/cjs/icons/file-zip').default;
// eslint-disable-next-line import/no-extraneous-dependencies,import/no-unresolved
const FileDocIcon = require('@digital-hig/icon/lib/cjs/icons/file-document').default;
// eslint-disable-next-line import/no-extraneous-dependencies,import/no-unresolved
const FilePDFIcon = require('@digital-hig/icon/lib/cjs/icons/file-pdf').default;
// eslint-disable-next-line import/no-extraneous-dependencies,import/no-unresolved
const FileGenericIcon = require('@digital-hig/icon/lib/cjs/icons/file-generic').default;

// eslint-disable-next-line import/no-extraneous-dependencies
const lightTheme = require('@digital-hig/theme-data/lib/build/json/light/design-tokens.json');

const modExports = {};
modExports.CLIENT_CONTEXT_CHANNEL = 'CLIENT_CONTEXT_CHANNEL';

modExports.LRS_APPID_LRNO = 'https://www.autodesk.com/learnone';
modExports.LRS_APPID_CSO = 'https://customersuccess.autodesk.com/';
modExports.LRS_APPID_AEX = 'https://www.autodesk.com/learn';
modExports.LRS_APPID_AU = 'https://www.autodesk.com/autodesk-university/';

modExports.APP_ACCOUNTS = 'APP_ACCOUNTS';
modExports.APP_PROFILE = 'APP_PROFILE';
modExports.LEARN_ONE_TARGET_VALUE = 'Learn ONE';
modExports.AEX_TARGET_VALUE = 'Learning and Certification';
modExports.CSO_TARGET_VALUE = 'Customer Success Hub';

modExports.API_TARGET_CHANNELS = JSON.stringify([modExports.LEARN_ONE_TARGET_VALUE, modExports.AEX_TARGET_VALUE, modExports.CSO_TARGET_VALUE]);

modExports.CLIENT_SOURCE_AEX = 'AEX';
modExports.CLIENT_SOURCE_CSO = 'CSO';
modExports.CLIENT_SOURCE_LRNO = 'LRNO';

modExports.SEGMENT_TREATMENT = 'Treatment';

modExports.ROUTER_BASENAME = 'ROUTER_BASENAME';

modExports.OXYGEN_REDIRECT_URL_KEY = 'autodesk_oxygen_redir_url';

modExports.LRS_VERB_COMPLETED = 'completed';
modExports.LRS_VERB_STARTED = 'started';
modExports.LRS_VERB_SEARCH = 'search';
modExports.LRS_VERB_FIND = 'find';
modExports.LRS_VERB_ACKNOWLEDGED = 'acknowledged';
modExports.LRS_VERB_CONSUMED = 'consumed';
modExports.LRS_VERB_VIEWED = 'viewed';
modExports.LRS_EXTENSIONS_CONTENTCHANGE = 'content change';
modExports.OBJECT_TYPE_PROBLEM = 'assessment';

// Fast Track constants
modExports.FAST_TRACK_STATUS = {
  UNASSIGNED: 'unassigned',
  IN_PROGRESS: 'in_progress',
  CANCELLED: 'cancelled',
};

modExports.LRS_CONTEXT_EXTENSIONS = 'extensions';
modExports.LRS_EXTENSIONS_PURPOSE = 'purpose';
modExports.LRS_EXTENSIONS_RETIRED = 'retired';

modExports.PRELOADED_STATE_KEY = '__PRELOADED_STATE__';

modExports.DEV_ENV = 'dev';
modExports.STAGE_ENV = 'stg';
modExports.PROD_ENV = 'prod';
modExports.PERF_ENV = 'perf';
modExports.MAINTENANCE_MODE = 'MAINTENANCE_MODE';

modExports.LOG_LEVEL = 'LOG_LEVEL';
modExports.LOG_LEVEL_DEBUG = 'debug';
modExports.LOG_LEVEL_INFO = 'info';
modExports.LOG_LEVEL_WARN = 'warn';
modExports.LOG_LEVEL_ERROR = 'error';

modExports.LOGGER_URL = 'LOGGER_URL';
modExports.ENVIRONMENT = 'ENVIRONMENT';
modExports.REQUEST_FLAGS = 'requestFlags';
modExports.IS_PREVIEW = 'isPreview';
modExports.COURSE_API_HOST = 'COURSE_API_HOST';
modExports.COURSE_PREVIEW_API_HOST = 'COURSE_PREVIEW_API_HOST';
modExports.COURSE_PREVIEW_REQUEST_HOST = 'COURSE_PREVIEW_REQUEST_HOST';
modExports.COURSE_DATA_HOST = 'CONTENTFUL_GRAPHQL_HOST';
modExports.LIST_API_HOST = 'LIST_API_HOST';
modExports.COACH_REQUEST_SERVICE_HOST = 'COACH_REQUEST_SERVICE_HOST';
modExports.COACH_REQUEST_SERVICE_HOST_PREVIEW = 'COACH_REQUEST_SERVICE_HOST_PREVIEW';
modExports.USE_MOCKS = 'useMocks';
modExports.SHARE_PREFIX = 'SHARE_PREFIX';
modExports.HOST = 'HOST';
modExports.CLARUS_LINK = 'CLARUS_LINK';
modExports.LL_PRODUCER_API = 'LL_PRODUCER_API';
modExports.LL_CONSUMER_API = 'LL_CONSUMER_API';
modExports.CERT_API = 'CERT_API';
modExports.SEARCH_API = 'SEARCH_API';
modExports.FILTER_API = 'FILTER_API';
modExports.CONTENTFUL_GRAPHQL_TOKEN = 'CONTENTFUL_GRAPHQL_TOKEN';
modExports.CONTENTFUL_PREVIEW_GRAPHQL_TOKEN = 'CONTENTFUL_PREVIEW_GRAPHQL_TOKEN';
modExports.CONTENTFUL_ENVIRONMENT_ID = 'CONTENTFUL_ENVIRONMENT_ID';
modExports.CONTENTFUL_SPACE_ID = 'CONTENTFUL_SPACE_ID';
modExports.HTML_MAX_AGE = 'HTML_MAX_AGE';
modExports.USER_PROFILE_API = 'USER_PROFILE_API';
modExports.ADSK_LAUNCH_DARKLY_CLIENTSIDE_KEY = 'ADSK_LAUNCH_DARKLY_CLIENTSIDE_KEY';

modExports.QUIZ_TYPE_SINGLE = 'multiplechoice';
modExports.QUIZ_TYPE_MULTI = 'multiselect';
modExports.QUIZ_TYPE_ORDERING = 'ordering';
modExports.QUIZ_TYPE_MATCHING = 'matching';

modExports.LEARNING_MODE_COURSEWARE = 'courseware';
modExports.LEARNING_MODE_MICROLEARNING = 'microlearning';

modExports.LIST_ID_BOOKMARKS = 'bookmarks';
modExports.LIST_ID_FOLLOWED = 'followed';
modExports.LIST_TYPE_COURSE = 'COURSE';
modExports.LIST_TYPE_MODULE = 'MODULE';
modExports.LIST_TYPE_COLLECTION = 'COLLECTION';
modExports.LIST_TYPE_LIST = 'LIST';
modExports.LIST_TITLE_MAX = 25;
modExports.LIST_DESCRIPTION_MAX = 100;

modExports.CATALOG_QUERY_PARAM = 'catFilter';
modExports.CATALOG_CARD_LOADING = 'loading';
modExports.CATALOG_CARD_BLANK = 'blank';
modExports.CATALOG_CARD_ROW = 'rowView';
modExports.CATALOG_CARD_LIST_EDIT = 'listEdit';
modExports.CATALOG_CARD_LIST_DELETED = 'listDeleted';
modExports.MFE_CARD = 'mfeCard';

modExports.COMPONENT_CURATED = 'curated';
modExports.COMPONENT_COURSE = 'course';
modExports.COMPONENT_INDEX = 'index';
modExports.COMPONENT_NOTFOUND = 'notFound';
modExports.COMPONENT_DASHBOARD = 'dashboard';
modExports.COMPONENT_CATALOG = 'catalog';
modExports.COMPONENT_TUTORIAL = 'tutorial';
modExports.COMPONENT_CURATED_TUTORIAL = 'curatedTutorial';
modExports.COMPONENT_UNIT_WRAPPER = 'unitWrapper';
modExports.COMPONENT_MODULE_UNIT_WRAPPER = 'moduleUnitWrapper';
modExports.COMPONENT_LIST = 'list';
modExports.COMPONENT_PLAN = 'plan';
modExports.COMPONENT_COLLECTION = 'collection';
modExports.COMPONENT_LIVE_CLASS_ENROLLMENT = 'liveClassEnrollment';
modExports.COMPONENT_COACHING_REQUEST = 'coachingRequest';
modExports.COMPONENT_COACHING_CATALOG = 'coachingCatalog';
modExports.COMPONENT_COACHING_CATALOG_DETAIL = 'coachingCatalogDetail';

modExports.PAGETYPE_TUTORIAL = 'tutorial';
modExports.PAGETYPE_MODULE = 'module';
modExports.PAGETYPE_CURATED = 'curated';
modExports.PAGETYPE_COURSE = 'course';
modExports.PAGETYPE_CATALOG = 'catalog';
modExports.PAGETYPE_COLLECTION = 'collection';
modExports.PAGETYPE_MODULE_UNIT = 'moduleUnit';
modExports.PAGETYPE_COURSE_UNIT = 'courseUnit';
modExports.PAGETYPE_COURSE_MODULE = 'courseModule';
modExports.PAGETYPE_COACHING_CATALOG = 'coachingCatalog';
modExports.PAGETYPE_COACHING_CATALOG_DETAIL = 'coachingCatalogDetail';

modExports.MY_LEARNING = 'myLearning';
modExports.MY_LEARNINGPLAN = 'myLearningPlan';
modExports.MY_LISTS = 'myLists';
modExports.MY_FOLLOWED_LISTS = 'myFollowedLists';
modExports.MY_BOOKMARKS = 'myBookmarks';
modExports.MY_CERTIFICATIONS = 'myCertifications';
modExports.COURSES_MODULES = 'coursesAndModules';
modExports.TUTORIALS_CURATEDS = 'tutorialsAndCurateds';
modExports.TUTORIALS_CURATEDLISTS = 'tutorialsAndCuratedLists';
modExports.COLLECTIONS = 'collections';

modExports.BANNER_TYPE_INFO = 'info';
modExports.BANNER_TYPE_SUCCESS = 'success';
modExports.BANNER_TYPE_WARNING = 'warning';
modExports.BANNER_TYPE_ERROR = 'error';

modExports.ITEM_TYPE_HTML = 'BlockHtml';
modExports.ITEM_TYPE_PDF = 'BlockPdf';

// Approved Autodesk-hosted domains from which iframes are allowed in BlockHtml content.
// Only hostnames listed here will survive DOMPurify sanitization; all others are stripped.
modExports.ALLOWED_IFRAME_DOMAINS = [
  'files.upskill-dev.autodesk.com',
];
modExports.ITEM_TYPE_VIDEO = 'BlockVideo';
modExports.ITEM_TYPE_QUIZ = 'BlockProblem';

modExports.OBJECT_TYPE_UNIT = 'resource';
modExports.OBJECT_TYPE_PROBLEM = 'assessment';
modExports.OBJECT_TYPE_COURSE = 'course';
modExports.OBJECT_TYPE_MODULE = 'module';
modExports.OBJECT_TYPE_QUERY = 'query';
modExports.OBJECT_TYPE_COLLECTION = 'collection';

modExports.EDC_SLUG_INDEX_HEADER = 'learn-one-unified-index-page-title';
modExports.EDC_SLUG_INDEX_WAYFINDING_INTRO = 'learn-one-unified-wayfinding-intro';
modExports.EDC_SLUG_INDEX_WAYFINDING_BLOCK1 = 'learn-one-unified-wayfinding-block-1';
modExports.EDC_SLUG_INDEX_WAYFINDING_BLOCK2 = 'learn-one-unified-wayfinding-block-2';
modExports.EDC_SLUG_INDEX_WAYFINDING_BLOCK3 = 'learn-one-unified-wayfinding-block-3';
modExports.EDC_SLUG_INDEX_WAYFINDING_BLOCK4 = 'learn-one-unified-wayfinding-block-4';
modExports.EDC_SLUG_INDEX_SELECT_PRODUCT = 'learn-one-unified-select-product';
modExports.EDC_SLUG_INDEX_TUTORIALS = 'learn-one-unified-index-tutorials-and-curated-lists';
modExports.EDC_SLUG_INDEX_COURSES = 'learn-one-unified-index-courses-and-modules';
modExports.EDC_SLUG_INDEX_COLLECTIONS = 'learn-one-unified-index-collections';
modExports.EDC_SLUG_INDEX_INDUSTRY = 'learn-one-unified-index-industry-and-capabilities';
modExports.EDC_SLUG_INDEX_CERTIFICATIONS = 'learn-one-unified-index-certifications';
modExports.EDC_SLUG_INDEX_EDUCATORS = 'learn-one-unified-index-educators';
modExports.EDC_SLUG_INDEX_MORE_LEARNING_BLOCK1 = 'learn-one-unified-index-more-learning-block-1';
modExports.EDC_SLUG_INDEX_MORE_LEARNING_BLOCK2 = 'learn-one-unified-index-more-learning-block-2';
modExports.EDC_SLUG_INDEX_MORE_LEARNING_BLOCK3 = 'learn-one-unified-index-more-learning-block-3';
modExports.EDC_SLUG_ENROLLMENT_REQUEST_EN_US = 'learn-one-enrollment-index-request-dictionary';
modExports.EDC_SLUG_ENROLLMENT_REQUEST_ZH_CN = 'learn-one-enrollment-index-request-dictionary-zh-CN';
modExports.EDC_SLUG_ENROLLMENT_REQUEST_KO_KR = 'learn-one-enrollment-index-request-dictionary-ko-KR';
modExports.EDC_SLUG_ENROLLMENT_REQUEST_JA_JP = 'learn-one-enrollment-index-request-dictionary-ja-JP';
modExports.EDC_SLUG_ENROLLMENT_REQUEST_IT_IT = 'learn-one-enrollment-index-request-dictionary-it-IT';
modExports.EDC_SLUG_ENROLLMENT_REQUEST_FR_FR = 'learn-one-enrollment-index-request-dictionary-fr-FR';
modExports.EDC_SLUG_ENROLLMENT_REQUEST_ES_ES = 'learn-one-enrollment-index-request-dictionary-es-ES';
modExports.EDC_SLUG_ENROLLMENT_REQUEST_DE_DE = 'learn-one-enrollment-index-request-dictionary-de-DE';
modExports.EDC_SLUG_COACHINGREQUEST_WAYFINDING_INTRO = 'learn-one-coachrequest-wayfinding-intro';
modExports.EDC_SLUG_COACHINGREQUEST_WAYFINDING_BLOCK1 = 'learn-one-coachrequest-wayfinding-block-1';
modExports.EDC_SLUG_COACHINGREQUEST_WAYFINDING_BLOCK2 = 'learn-one-coachrequest-wayfinding-block-2';
// Industry blocks
modExports.EDC_SLUG_AEC_INDUSTRY_BLOCK = 'aec-industry-block';
modExports.EDC_SLUG_MFG_INDUSTRY_BLOCK = 'mfg-industry-block';
modExports.EDC_SLUG_MEDIA_AND_ENTERTAINMENT_INDUSTRY_BLOCK = 'media-and-entertainment-industry-block';
modExports.EDC_SLUG_EDUCATION_INDUSTRY_BLOCK = 'education-industry-block';
modExports.EDC_SLUG_EARN_AN_AUTODESK_CERT_BLOCK = 'earn-an-autodesk-certification-block';

// Personalized Constants
modExports.EDC_SLUG_PERSONALIZED_HEADER = 'learn-one-authenticated-index-page-title';
modExports.EDC_SLUG_PERSONALIZED_TUTORIALS = 'learn-one-authenticated-index-tutorials-and-curated-lists';
modExports.EDC_SLUG_PERSONALIZED_CERTIFICATIONS = 'index-page-certification';
modExports.EDC_SLUG_PERSONALIZED_EDUCATORS = 'learn-one-unified-index-educators';
modExports.EDC_SLUG_PERSONALIZED_COURSES = 'learn-one-authenticated-index-courses-and-modules';
modExports.EDC_SLUG_PERSONALIZED_COLLECTIONS = 'learn-one-authenticated-index-collections';
modExports.EDC_SLUG_PERSONALIZED_SELECT_PRODUCT = 'learn-one-authenticated-product-entitlement';
modExports.EDC_SLUG_PERSONALIZED_MORE_LEARNING_BLOCK1 = 'learn-one-unified-index-more-learning-block-1';
modExports.EDC_SLUG_PERSONALIZED_MORE_LEARNING_BLOCK2 = 'learn-one-unified-index-more-learning-block-2';
modExports.EDC_SLUG_PERSONALIZED_MORE_LEARNING_BLOCK3 = 'learn-one-unified-index-more-learning-block-3';
modExports.EDC_SLUGS_PERSONALIZED_NO_PRODUCT_SELECTED = 'learn-one-authenticated-no-product-entitlements';
modExports.EDC_SLUG_INDEX_SELECT_PRODUCT = 'learn-one-unified-select-product';

modExports.LEARN_LIVE_ENROLLMENT_HOST = 'LEARN_LIVE_ENROLLMENT_HOST';
modExports.SUCCESS_PLAN_URL = 'SUCCESS_PLAN_URL';
modExports.LEARN_LIVE_COACHING_REQUEST_HOST = 'LEARN_LIVE_COACHING_REQUEST_HOST';
modExports.LEARN_LIVE_SERVICES_HOST = 'LEARN_LIVE_SERVICES_HOST';
// PURPOSE: Keys that connect with LearningPlan Services
modExports.LEARNING_PLAN_HOST_COMMON = 'LEARNING_PLAN_HOST_COMMON';

modExports.EDC_SLUG_CATALOG_INTRO = 'catalog-page-intro';
modExports.EDC_SLUG_COACHING_CATALOG_INTRO = 'coaching-catalog-page-intro';

modExports.EDC_SLUGS_CATALOG = [modExports.EDC_SLUG_CATALOG_INTRO];
modExports.EDC_SLUGS_COACHING_CATALOG = [modExports.EDC_SLUG_COACHING_CATALOG_INTRO];

modExports.LOGIN_EXPERIMENT = 'LoginExperiment';
modExports.LOGIN_EXPERIMENT_SEGMENT1 = 'LoginExperimentSegment1';
modExports.LOGIN_EXPERIMENT_SEGMENT2 = 'LoginExperimentSegment2';

modExports.PERSONALIZATION_EXPERIMENT = 'PersonalizationExperiment';
modExports.PERSONALIZATION_EXPERIMENT_CONTROL = 'control';
modExports.PERSONALIZATION_EXPERIMENT_TREATMENT = 'treatment';
modExports.PERSONALIZATION_EXPERIMENT_ACTIVETRIALONLY = 'ActiveTrialOnly';
modExports.PERSONALIZATION_EXPERIMENT_ACTIVECOMMONLY = 'ActiveCommOnly';
modExports.PERSONALIZATION_EXPERIMENT_ACTIVETRIALANDCOMM = 'ActiveTrialAndComm';
modExports.PERSONALIZATION_EXPERIMENT_EXPIREDTRIALONLY = 'ExpiredTrialOnly';
modExports.PERSONALIZATION_EXPERIMENT_ATOTREATMENT = 'ATOTreatment';
modExports.PERSONALIZATION_EXPERIMENT_ACOTREATMENT = 'ACOTreatment';
modExports.PERSONALIZATION_EXPERIMENT_ATACTREATMENT = 'ATACTreatment';
modExports.PERSONALIZATION_EXPERIMENT_ATOCONTROL = 'ATOControl';
modExports.PERSONALIZATION_EXPERIMENT_ACOCONTROL = 'ACOControl';
modExports.PERSONALIZATION_EXPERIMENT_ATACCONTROL = 'ATACControl';
modExports.PERSONALIZATION_EXPERIMENT_ETOCONTROL = 'ETOControl';
modExports.PERSONALIZATION_EXPERIMENT_ETOTREATMENT = 'ETOTreatment';
modExports.PERSONALIZATION_EXPERIMENT_TRIAL_ENTITLEMENT = 'TRIAL';
modExports.PERSONALIZATION_EXPERIMENT_COMMERCIAL_ENTITLEMENT = 'COMMERCIAL';

modExports.INDUSTRY_RELEVANT_LEARNING_AND_CERT_PREP = 'IndustryRelevantLearningAndCertPrep';
modExports.IRLCP_EXPERIMENT_CONTROL = 'IRLCPControl';
modExports.IRLCP_EXPERIMENT_TREATMENT = 'IRLCPTreatment';

modExports.EDC_SLUGS_INDEX = [
  modExports.EDC_SLUG_INDEX_HEADER,
  modExports.EDC_SLUG_INDEX_WAYFINDING_INTRO,
  modExports.EDC_SLUG_INDEX_WAYFINDING_BLOCK1,
  modExports.EDC_SLUG_INDEX_WAYFINDING_BLOCK2,
  modExports.EDC_SLUG_INDEX_WAYFINDING_BLOCK3,
  modExports.EDC_SLUG_INDEX_WAYFINDING_BLOCK4,
  modExports.EDC_SLUG_INDEX_SELECT_PRODUCT,
  modExports.EDC_SLUG_CATALOG_INTRO,
  modExports.EDC_SLUG_INDEX_TUTORIALS,
  modExports.EDC_SLUG_INDEX_COURSES,
  modExports.EDC_SLUG_INDEX_COLLECTIONS,
  modExports.EDC_SLUG_INDEX_INDUSTRY,
  modExports.EDC_SLUG_INDEX_CERTIFICATIONS,
  modExports.EDC_SLUG_INDEX_EDUCATORS,
  modExports.EDC_SLUG_INDEX_MORE_LEARNING_BLOCK1,
  modExports.EDC_SLUG_INDEX_MORE_LEARNING_BLOCK2,
  modExports.EDC_SLUG_INDEX_MORE_LEARNING_BLOCK3,
  modExports.EDC_SLUG_AEC_INDUSTRY_BLOCK,
  modExports.EDC_SLUG_MFG_INDUSTRY_BLOCK,
  modExports.EDC_SLUG_MEDIA_AND_ENTERTAINMENT_INDUSTRY_BLOCK,
  modExports.EDC_SLUG_EDUCATION_INDUSTRY_BLOCK,
  modExports.EDC_SLUG_EARN_AN_AUTODESK_CERT_BLOCK,
];

modExports.EDC_SLUGS_PERSONALIZED = [
  modExports.EDC_SLUG_PERSONALIZED_HEADER,
  modExports.EDC_SLUG_PERSONALIZED_SELECT_PRODUCT,
  modExports.EDC_SLUGS_PERSONALIZED_NO_PRODUCT_SELECTED,
  modExports.EDC_SLUG_PERSONALIZED_TUTORIALS,
  modExports.EDC_SLUG_PERSONALIZED_COURSES,
  modExports.EDC_SLUG_PERSONALIZED_COLLECTIONS,
  modExports.EDC_SLUG_INDEX_INDUSTRY,
  modExports.EDC_SLUG_PERSONALIZED_CERTIFICATIONS,
  modExports.EDC_SLUG_PERSONALIZED_EDUCATORS,
  modExports.EDC_SLUG_PERSONALIZED_MORE_LEARNING_BLOCK1,
  modExports.EDC_SLUG_PERSONALIZED_MORE_LEARNING_BLOCK2,
  modExports.EDC_SLUG_PERSONALIZED_MORE_LEARNING_BLOCK3,
  modExports.EDC_SLUG_INDEX_SELECT_PRODUCT,
];

modExports.EDC_SLUGS_ENROLLMENT_EN_US = [
  modExports.EDC_SLUG_ENROLLMENT_REQUEST_EN_US,
];

modExports.EDC_SLUGS_ENROLLMENT_ZH_CN = [
  modExports.EDC_SLUG_ENROLLMENT_REQUEST_ZH_CN,
];

modExports.EDC_SLUGS_ENROLLMENT_KO_KR = [
  modExports.EDC_SLUG_ENROLLMENT_REQUEST_KO_KR,
];

modExports.EDC_SLUGS_ENROLLMENT_JA_JP = [
  modExports.EDC_SLUG_ENROLLMENT_REQUEST_JA_JP,
];

modExports.EDC_SLUGS_ENROLLMENT_IT_IT = [
  modExports.EDC_SLUG_ENROLLMENT_REQUEST_IT_IT,
];

modExports.EDC_SLUGS_ENROLLMENT_FR_FR = [
  modExports.EDC_SLUG_ENROLLMENT_REQUEST_FR_FR,
];

modExports.EDC_SLUGS_ENROLLMENT_ES_ES = [
  modExports.EDC_SLUG_ENROLLMENT_REQUEST_ES_ES,
];

modExports.EDC_SLUGS_ENROLLMENT_DE_DE = [
  modExports.EDC_SLUG_ENROLLMENT_REQUEST_DE_DE,
];

modExports.VALID_AWS_ENVS = [modExports.DEV_ENV, modExports.STAGE_ENV, modExports.PROD_ENV, modExports.PERF_ENV];
modExports.VALID_LOG_LEVELS = [
  modExports.LOG_LEVEL_DEBUG,
  modExports.LOG_LEVEL_INFO,
  modExports.LOG_LEVEL_WARN,
  modExports.LOG_LEVEL_ERROR,
];

modExports.ERROR_TYPE_404 = '404';
modExports.ERROR_TYPE_XHR = 'XHR';
modExports.ERROR_TYPE_IFRAME = 'IFRAME';
modExports.ERROR_TYPE_BROWSER = 'BROWSER';
modExports.ERROR_TYPE_LIST_PERMISSION = 'LIST_PERMISSION';

modExports.AA_EVENT_START = 'start';
modExports.AA_EVENT_CONTINUE = 'continue';
modExports.AA_EVENT_COMPLETE = 'complete';
modExports.AA_EVENT_REVISIT = 'revisit';

modExports.AA_SESSION_KEY_COURSE_CONTINUE = 'LRNOASKCC';
modExports.AA_SESSION_KEY_COURSE_REVISIT = 'LRNOASKCR';
modExports.AA_SESSION_KEY_MODULE_CONTINUE = 'LRNOASKMC';
modExports.AA_SESSION_KEY_MODULE_REVISIT = 'LRNOASKMR';

modExports.LOCAL_STORAGE_LRS_KEY = 'LRNO.LearnOneRecords';
modExports.LOCAL_STORAGE_VIEW_COUNT_KEY = '_uavc';
modExports.LOCAL_STORAGE_ANONYMOUS_ID = 'anonymous';

modExports.UNAUTHMODAL_SHOWN = 'UNAUTHMODAL_SHOWN';

modExports.NAV_ITEMS = 'navItems';

modExports.RETRY_COUNT = 2;

modExports.SEARCH_ACTION_SEARCH = 'search';
modExports.SEARCH_ACTION_FILTER = 'filter';

modExports.SUCCESS_PROMISE_DELETED = 'deleted';
modExports.SUCCESS_PROMISE_CANCELLED = 'cancelled';

modExports.LIST_PERMISSIONS_PRIVATE = 'PRIVATE';
modExports.LIST_PERMISSIONS_UNLISTED = 'UNLISTED';
modExports.LIST_TITLE_MAX = 25;
modExports.LIST_DESCRIPTION_MAX = 300;

modExports.UGC_FILTER_KEY = 'UGC_FILTER_KEY';
modExports.UGC_FILTER_API = 'UGC_FILTER_API';

modExports.PKCE_CLIENT_ID = 'PKCE_CLIENT_ID';
modExports.PKCE_ENV = 'PKCE_ENV';
modExports.PKCE_PROFILE_HOST = 'PKCE_PROFILE_HOST';

modExports.VERSION = 'VERSION';

modExports.COURSE_TYPE_SKILL_BUILDER = 'Skill builder';
modExports.COURSE_TYPE_OUTCOMES_CAPABILITIES = 'Outcomes and capabilities';
modExports.COURSE_TYPE_CERT_PREP = 'Certification prep';
modExports.CART_COUNT_URL = 'CART_COUNT_URL';

modExports.FILEMANAGER_PROXY_HOST = 'FILEMANAGER_PROXY_HOST';

modExports.COURSE_LEFT_NAV = ['Course overivew', 'Course outline', 'Teaching supplements', 'Announcements', 'Related learning'];
modExports.STANDALONE_MODULE_LEFT_NAV = ['Module overivew', 'Module downloads', 'Module outline', 'Teaching supplements', 'Announcements', 'Related learning'];

modExports.COMPANY_NAME = 'COMPANY_NAME';
modExports.COACHING_TYPE = 'COACHING_TYPE';
modExports.SUBSCRIPTION = 'SUBSCRIPTION';
modExports.OBJECTIVES = 'OBJECTIVES';
modExports.AVAILABILITY = 'AVAILABILITY';
modExports.REQUEST_REVIEW = 'REQUEST_REVIEW';
modExports.PREMIUM_DESCRIPTION = 'PREMIUM_DESCRIPTION';
modExports.FAQ = 'FAQ';
modExports.FF_COACHING_REQUEST = 'FF_COACHING_REQUEST';
modExports.LEARN_LIVE_COACHING_REQUEST_SUBMIT_VERSION = 'LEARN_LIVE_COACHING_REQUEST_SUBMIT_VERSION';
modExports.COACHING_OVERVIEW_URL = 'COACHING_OVERVIEW_URL';
modExports.COACHING_SUBSCRIPTION_TYPE_MAP = { premium: { id: 1, label: 'Premium' }, enterprise: { id: 2, label: 'Enterprise' } };

modExports.APP_PROBLEM_EDITOR = 'problemEditor';

modExports.ENABLE_ADOBE_TARGET = 'ENABLE_ADOBE_TARGET';
modExports.DATA_SCIENCE_API_HOST = 'DATA_SCIENCE_API_HOST';
modExports.DATA_SCIENCE_XAPI_KEY = 'DATA_SCIENCE_XAPI_KEY';

modExports.AUTHENTICATION_HOST = 'AUTHENTICATION_HOST';
modExports.TWO_LEGGED_CLIENT_ID = 'TWO_LEGGED_CLIENT_ID';
modExports.TWO_LEGGED_CLIENT_SECRET = 'TWO_LEGGED_CLIENT_SECRET';
modExports.V3_LICENSE_API_HOST = 'V3_LICENSE_API_HOST';
modExports.VIDEO_LOCALIZATION_HOST = 'VIDEO_LOCALIZATION_HOST';
modExports.VIDEO_LOCALIZATION_API_KEY = 'VIDEO_LOCALIZATION_API_KEY';
modExports.UNIVERSAL_HEADER = 'UNIVERSAL_HEADER';
modExports.UNIVERSAL_HEADER_APP = 'UNIVERSAL_HEADER_APP';
modExports.UNIVERSAL_FOOTER = 'UNIVERSAL_FOOTER';
modExports.UNIVERSAL_HEADER_CLIENT_APP = 'UNIVERSAL_HEADER_CLIENT_APP';
modExports.UNIVERSAL_FOOTER_CLIENT_APP = 'UNIVERSAL_FOOTER_CLIENT_APP';
modExports.USE_SSR_HNF = 'USE_SSR_HNF';
modExports.WTIH_APIKEY = 'WTIH_APIKEY';
modExports.WTIH_SECRET = 'WTIH_SECRET';
/*
 This object is a key/value list of AWS Lambda Environment Variables required for the application.
 The value of each key is an object that contains:
    default (required): default value for this key if it is not present in the env
    validator (optional): a function to validate the value before setting it.  This function should
    return a boolean value.  If false the application will use the default value instead of the value
    that failed validation.
 */
modExports.AWS_ENV_VARS = {
  ENVIRONMENT: {
    default: modExports.DEV_ENV, // Reinstated default value for local development
    validator: (v) => modExports.VALID_AWS_ENVS.includes(v),
  },
  LOG_LEVEL: {
    default: modExports.LOG_LEVEL_DEBUG,
    validator: (v) => modExports.VALID_LOG_LEVELS.includes(v),
  },
  HTML_MAX_AGE: {
    default: '86400',
    validator: (v) => RegExp(/^\d+$/).test(v),
  },
  LOGGER_URL: {},
};

// Object to contain values of learning plan actions
modExports.LEARNING_PLAN_ACTIONS = {
  ACK_UNASSIGNED: 'ack',
};

// Object to contain assigned learning status constants
modExports.ASSIGNED_LEARNING_STATUS = {
  NEW_ASSIGNMENT: {
    label: 'New',
    value: 'new',
  },
  IN_PROGRESS: {
    label: 'In-progress',
    value: 'inprogress',
  },
  COMPLETED: {
    label: 'Completed',
    value: 'completed',
  },
};

modExports.LD_CSO_BUSINESS_TIER_FLAG = 'businessTierCsOfferingNav';
modExports.LD_CSO_COACHING_CATALOG_FLAG = 'businessTierCsCoachingCatalog';
modExports.LD_CSO_FAST_TRACK_FLAG = 'businessTierCsOfferingFastTrack';
modExports.LD_INVENTOR_CTA_BANNER_FLAG = 'inventorCtaBannerRollout';
modExports.INVENTOR_CTA_BANNER_SLUG = 'inventor-quick-start-guide';
modExports.INVENTOR_CTA_BANNER_URL = 'INVENTOR_CTA_BANNER_URL';
modExports.INVENTOR_EXPERIMENT_ID = 'inventor-cta-banner';
modExports.INVENTOR_EXPERIMENT_GROUP_TEST = 'inventor-test-group';
modExports.INVENTOR_EXPERIMENT_GROUP_CONTROL = 'inventor-control-group';
modExports.INVENTOR_EXPERIMENT_GROUP_SUBSCRIPTION = 'inventor-subscription-group';

// eslint-disable-next-line max-len
modExports.REQUEST_FORM_FAST_TRACK_DISCOVERY_CALL_AVAILABILITY_LABEL = 'A member of our team will analyze your request and reach out to you to discuss your fast track service needs in greater detail.';
// eslint-disable-next-line max-len
modExports.REQUEST_FORM_DEFAULT_DISCOVERY_CALL_AVAILABILITY_LABEL = 'We will reach out to schedule a specific time to discuss your request in greater detail and make our best effort to accommodate one of these preferred times.';

/*
 This object contains Constants who's values are relative to the environment the application is running in.
 */
modExports.ENVIRONMENT_CONSTANTS = {
  dev: {
    ENVIRONMENT: modExports.DEV_ENV,
    LOG_LEVEL: 'debug',
    COURSE_API_HOST: 'https://main-app.learn-one-dev.autodesk.com',
    COURSE_PREVIEW_API_HOST:
      'https://7txzsfq1y9.execute-api.us-east-1.amazonaws.com',
    CONTENTFUL_GRAPHQL_HOST: 'https://graphql.contentful.com',
    CONTENTFUL_ENVIRONMENT_ID: 'development',
    CONTENTFUL_SPACE_ID: 'ooioaq2tbzyk',
    LL_PRODUCER_API: 'https://lrs-main.learn-one-dev.autodesk.com/v1/producer',
    LL_CONSUMER_API: 'https://lrs-main.learn-one-dev.autodesk.com/v1/consumer',
    LIST_API_HOST: 'https://lists-main.learn-one-dev.autodesk.com/api/v1',
    SHARE_PREFIX: 'https://app.upskill-dev.autodesk.com',
    CLARUS_LINK: 'https://autodesk.clarus-stage.com',
    CERT_API:
      'https://api-credentialing-dev.autodesk.com/v1/certificate/generate',
    SEARCH_API: 'https://kp.services-stage.autodesk.com/service/rest/unifiedlearn/v1/search',
    FILTER_API: 'https://kp.services-stage.autodesk.com/service/rest/unifiedlearn/v1/filters',
    PKCE_CLIENT_ID: '4ty7y6VbGI1BGrHyrWHk5Wsf0VFgDAAY',
    PKCE_ENV: 'stg',
    PKCE_PROFILE_HOST: 'https://developer-stg.api.autodesk.com',
    ROUTER_BASENAME: '/learn',
    HTML_MAX_AGE: '86400',
    LEARN_LIVE_ENROLLMENT_HOST: 'https://main.learnlive-enrollment-api-dev.autodesk.com',
    LEARN_LIVE_COACHING_REQUEST_HOST: 'https://learnlive-coachingrequest-api-dev.autodesk.com',
    LEARN_LIVE_SERVICES_HOST: 'https://main.learn-live-services-dev.autodesk.com',
    LEARNING_PLAN_HOST_COMMON: 'https://learn-plan-main.learn-one-dev.autodesk.com',
    WTIH: {
      APPID: 'learnone',
    },
    CART_COUNT_URL: 'https://cart-api.ocstg.autodesk.com/v1/cart/count/{{cartId}}',
    FILEMANAGER_PROXY_HOST: 'false',
    CLIENT_CONTEXT_CHANNEL: `${modExports.CLIENT_SOURCE_AEX},${modExports.CLIENT_SOURCE_CSO},${modExports.CLIENT_SOURCE_LRNO}`,
    UGC_FILTER_API: 'https://offensive-detector-dev.ml.dhx.autodesk.com/v1/keywords',
    FF_COACHING_REQUEST: 'true',
    LEARN_LIVE_COACHING_REQUEST_SUBMIT_VERSION: 'v2',
    COACHING_OVERVIEW_URL: 'https://www-pt.autodesk.com/coaching/overview',
    INVENTOR_CTA_BANNER_URL: 'https://www-pt.autodesk.com/products/inventor/overview',
    APP_ACCOUNTS: 'https://accounts-dev.autodesk.com/',
    APP_PROFILE: 'https://profile-dev.autodesk.com/',
    ENABLE_ADOBE_TARGET: 'true',
    USER_PROFILE_API: 'https://developer-stg.api.autodesk.com/unifieduserprofile',
    DATA_SCIENCE_API_HOST: 'https://personalize-dev.ml.dhx.autodesk.com/v2/features',
    AUTHENTICATION_HOST: 'https://developer-stg.api.autodesk.com/authentication/v2/token',
    V3_LICENSE_API_HOST: 'https://api-stg.v3license.access.np.clic.autodesk.com/v1/licensable-features',
    VIDEO_LOCALIZATION_HOST: 'https://data-stg.beehive.autodesk.com/v1/get-video',
    UNIVERSAL_HEADER: 'https://uh-static.efddotcom-dev.autodesk.com/dotcom/en-US/uh.html',
    UNIVERSAL_FOOTER: 'https://www-pt.autodesk.com/content/experience-fragments/autodesk/en/universal-footer/master.content.html',
    UNIVERSAL_HEADER_APP: 'https://swc-stg.autodesk.com/web-mfe/universal-header-ssr/stage/v1/app.js',
    UNIVERSAL_HEADER_CLIENT_APP: 'https://swc-stg.autodesk.com/web-mfe/universal-header/stage/v1/app.js',
    UNIVERSAL_FOOTER_CLIENT_APP: 'https://swc-stg.autodesk.com/web-mfe/universal-footer/stage/v1/app.js',
    USE_SSR_HNF: 'true',
    ADSK_LAUNCH_DARKLY_CLIENTSIDE_KEY: '5be4d1226292ac2ff6fd2c41',
    SUCCESS_PLAN_URL: 'https://www-pt.autodesk.com/buying/plans',
    // CJS Web SDK Configuration
    CJS_ENABLED: 'true',
    FORGE_CLIENT_ID: '4ty7y6VbGI1BGrHyrWHk5Wsf0VFgDAAY', // Same as PKCE_CLIENT_ID for dev
    CJS_ENV: 'dev',
    CJS_EVENT_GENERATOR: 'learn-one-spa',
    CJS_AUTO_PAGE_CAPTURE: 'true',
    CJS_AUTO_LINK_CAPTURE: 'true',
    CJS_ADP_CDN: 'ase-cdn-stg',
    CJS_SWC_CDN: 'swc-stg',
  },
  stg: {
    ENVIRONMENT: modExports.STAGE_ENV,
    LOG_LEVEL: 'warn',
    COURSE_API_HOST: 'https://www-pt.autodesk.com',
    COURSE_PREVIEW_API_HOST:
      'https://7txzsfq1y9.execute-api.us-east-1.amazonaws.com',
    CONTENTFUL_GRAPHQL_HOST: 'https://graphql.contentful.com',
    CONTENTFUL_ENVIRONMENT_ID: 'stage',
    CONTENTFUL_SPACE_ID: 'ooioaq2tbzyk',
    LL_PRODUCER_API: 'https://lrs-main.learn-one-stg.autodesk.com/v1/producer',
    LL_CONSUMER_API: 'https://lrs-main.learn-one-stg.autodesk.com/v1/consumer',
    LIST_API_HOST: 'https://lists-main.learn-one-stg.autodesk.com/api/v1',
    SHARE_PREFIX: 'https://app.upskill-stg.autodesk.com',
    CLARUS_LINK: 'https://autodesk.clarus-stage.com',
    CERT_API:
      'https://api-credentialing-staging.autodesk.com/v1/certificate/generate',
    SEARCH_API: 'https://kp.services-stage.autodesk.com/service/rest/unifiedlearn/v1/search',
    FILTER_API: 'https://kp.services-stage.autodesk.com/service/rest/unifiedlearn/v1/filters',
    PKCE_CLIENT_ID: '4ty7y6VbGI1BGrHyrWHk5Wsf0VFgDAAY',
    PKCE_ENV: 'stg',
    PKCE_PROFILE_HOST: 'https://developer-stg.api.autodesk.com',
    ROUTER_BASENAME: '/learn',
    HTML_MAX_AGE: '86400',
    LEARN_LIVE_ENROLLMENT_HOST: 'https://main.learnlive-enrollment-api-stg.autodesk.com',
    LEARN_LIVE_COACHING_REQUEST_HOST: 'https://learnlive-coachingrequest-api-stg.autodesk.com',
    LEARN_LIVE_SERVICES_HOST: 'https://main.learn-live-services-stg.autodesk.com',
    LEARNING_PLAN_HOST_COMMON: 'https://learn-plan-main.learn-one-stg.autodesk.com',
    WTIH: {
      APPID: 'learnone',
    },
    CART_COUNT_URL: 'https://cart-api.ocstg.autodesk.com/v1/cart/count/{{cartId}}',
    FILEMANAGER_PROXY_HOST: 'false',
    CLIENT_CONTEXT_CHANNEL: `${modExports.CLIENT_SOURCE_AEX},${modExports.CLIENT_SOURCE_CSO},${modExports.CLIENT_SOURCE_LRNO}`,
    UGC_FILTER_API: 'https://offensive-detector-stg.ml.dhx.autodesk.com/v1/keywords',
    FF_COACHING_REQUEST: 'true',
    LEARN_LIVE_COACHING_REQUEST_SUBMIT_VERSION: 'v2',
    COACHING_OVERVIEW_URL: 'https://www-pt.autodesk.com/coaching/overview',
    INVENTOR_CTA_BANNER_URL: 'https://www-pt.autodesk.com/products/inventor/overview',
    APP_ACCOUNTS: 'https://accounts-staging.autodesk.com/',
    APP_PROFILE: 'https://profile-stg.autodesk.com/',
    ENABLE_ADOBE_TARGET: 'true',
    USER_PROFILE_API: 'https://developer-stg.api.autodesk.com/unifieduserprofile',
    DATA_SCIENCE_API_HOST: 'https://personalize-stg.ml.dhx.autodesk.com/v2/features',
    AUTHENTICATION_HOST: 'https://developer-stg.api.autodesk.com/authentication/v2/token',
    V3_LICENSE_API_HOST: 'https://api-stg.v3license.access.np.clic.autodesk.com/v1/licensable-features',
    VIDEO_LOCALIZATION_HOST: 'https://data-stg.beehive.autodesk.com/v1/get-video',
    UNIVERSAL_HEADER: 'https://uh-static.efddotcom-stg.autodesk.com/dotcom/en-US/uh.html',
    UNIVERSAL_HEADER_APP: 'https://swc-stg.autodesk.com/web-mfe/universal-header-ssr/stage/v1/app.js',
    UNIVERSAL_FOOTER: 'https://www-pt.autodesk.com/content/experience-fragments/autodesk/en/universal-footer/master.content.html',
    UNIVERSAL_HEADER_CLIENT_APP: 'https://swc-stg.autodesk.com/web-mfe/universal-header/stage/v1/app.js',
    UNIVERSAL_FOOTER_CLIENT_APP: 'https://swc-stg.autodesk.com/web-mfe/universal-footer/stage/v1/app.js',
    USE_SSR_HNF: 'true',
    ADSK_LAUNCH_DARKLY_CLIENTSIDE_KEY: '5be4d1228da22f2fe9cffa94',
    SUCCESS_PLAN_URL: 'https://www-pt.autodesk.com/buying/plans',
    // CJS Web SDK Configuration
    CJS_ENABLED: 'true',
    FORGE_CLIENT_ID: '4ty7y6VbGI1BGrHyrWHk5Wsf0VFgDAAY', // Same as PKCE_CLIENT_ID for stg
    CJS_ENV: 'stg',
    CJS_EVENT_GENERATOR: 'learn-one-spa',
    CJS_AUTO_PAGE_CAPTURE: 'true',
    CJS_AUTO_LINK_CAPTURE: 'true',
    CJS_ADP_CDN: 'ase-cdn-stg',
    CJS_SWC_CDN: 'swc-stg',
  },
  prod: {
    ENVIRONMENT: modExports.PROD_ENV,
    LOG_LEVEL: 'error',
    COURSE_API_HOST: 'https://www.autodesk.com',
    COURSE_PREVIEW_API_HOST:
      'https://7txzsfq1y9.execute-api.us-east-1.amazonaws.com',
    CONTENTFUL_GRAPHQL_HOST: 'https://graphql.contentful.com',
    CONTENTFUL_ENVIRONMENT_ID: 'master',
    CONTENTFUL_SPACE_ID: 'ooioaq2tbzyk',
    LL_PRODUCER_API: 'https://lrs-main.learn-one.autodesk.com/v1/producer',
    LL_CONSUMER_API: 'https://lrs-main.learn-one.autodesk.com/v1/consumer',
    CLARUS_LINK: 'https://autodesk.useclarus.com',
    CERT_API: 'https://api-credentialing.autodesk.com/v1/certificate/generate',
    SEARCH_API: 'https://kp.services.autodesk.com/service/rest/unifiedlearn/v1/search',
    FILTER_API: 'https://kp.services.autodesk.com/service/rest/unifiedlearn/v1/filters',
    LIST_API_HOST: 'https://lists-main.learn-one.autodesk.com/api/v1',
    PKCE_CLIENT_ID: 'Zk2dzV3DhtuoJs2q9bTAf5oyUir3lMuG',
    PKCE_ENV: 'prod',
    PKCE_PROFILE_HOST: 'https://developer.api.autodesk.com',
    ROUTER_BASENAME: '/learn',
    HTML_MAX_AGE: '86400',
    LEARN_LIVE_ENROLLMENT_HOST: 'https://main.learnlive-enrollment-api.autodesk.com',
    LEARN_LIVE_COACHING_REQUEST_HOST: 'https://learnlive-coachingrequest-api.autodesk.com',
    LEARN_LIVE_SERVICES_HOST: 'https://main.learn-live-services.autodesk.com',
    LEARNING_PLAN_HOST_COMMON: 'https://learn-plan-main.learn-one.autodesk.com',
    WTIH: {
      APPID: 'learnone',
    },
    CART_COUNT_URL: 'https://cart-api.oc.autodesk.com/v1/cart/count/{{cartId}}',
    FILEMANAGER_PROXY_HOST: 'false',
    CLIENT_CONTEXT_CHANNEL: `${modExports.CLIENT_SOURCE_AEX},${modExports.CLIENT_SOURCE_CSO},${modExports.CLIENT_SOURCE_LRNO}`,
    UGC_FILTER_API: 'https://offensive-detector.ml.dhx.autodesk.com/v1/keywords',
    FF_COACHING_REQUEST: 'false',
    LEARN_LIVE_COACHING_REQUEST_SUBMIT_VERSION: 'v2',
    COACHING_OVERVIEW_URL: 'https://www.autodesk.com/coaching/overview',
    INVENTOR_CTA_BANNER_URL: 'https://www.autodesk.com/products/inventor/overview',
    APP_ACCOUNTS: 'https://accounts.autodesk.com/',
    APP_PROFILE: 'https://profile.autodesk.com/',
    ENABLE_ADOBE_TARGET: 'true',
    USER_PROFILE_API: 'https://developer.api.autodesk.com/unifieduserprofile',
    DATA_SCIENCE_API_HOST: 'https://personalize.ml.dhx.autodesk.com/v2/features',
    AUTHENTICATION_HOST: 'https://developer.api.autodesk.com/authentication/v2/token',
    V3_LICENSE_API_HOST: 'https://api.v3license.access.clic.autodesk.com/v1/licensable-features',
    VIDEO_LOCALIZATION_HOST: 'https://micro.beehive.autodesk.com/v1/get-video',
    UNIVERSAL_HEADER: 'https://uh-static.efddotcom.autodesk.com/dotcom/en-US/uh.html',
    UNIVERSAL_HEADER_APP: 'https://swc.autodesk.com/web-mfe/universal-header-ssr/v1/app.js',
    UNIVERSAL_FOOTER: 'https://www.autodesk.com/content/experience-fragments/autodesk/en/universal-footer/master.content.html',
    UNIVERSAL_HEADER_CLIENT_APP: 'https://swc.autodesk.com/web-mfe/universal-header/v1/app.js',
    UNIVERSAL_FOOTER_CLIENT_APP: 'https://swc.autodesk.com/web-mfe/universal-footer/v1/app.js',
    USE_SSR_HNF: 'true',
    ADSK_LAUNCH_DARKLY_CLIENTSIDE_KEY: '5be4d121c69abc2fdb0ac124',
    SUCCESS_PLAN_URL: 'https://www.autodesk.com/buying/plans',
    // CJS Web SDK Configuration
    CJS_ENABLED: 'true',
    FORGE_CLIENT_ID: 'Zk2dzV3DhtuoJs2q9bTAf5oyUir3lMuG', // Same as PKCE_CLIENT_ID for prod
    CJS_ENV: 'prd',
    CJS_EVENT_GENERATOR: 'learn-one-spa',
    CJS_AUTO_PAGE_CAPTURE: 'true',
    CJS_AUTO_LINK_CAPTURE: 'true',
    CJS_ADP_CDN: 'ase-cdn',
    CJS_SWC_CDN: 'swc',
  },
  perf: {
    ENVIRONMENT: modExports.PROD_ENV,
    LOG_LEVEL: 'error',
    COURSE_API_HOST: 'https://www.upskill-perf.autodesk.com',
    COURSE_PREVIEW_API_HOST:
      'https://7txzsfq1y9.execute-api.us-east-1.amazonaws.com',
    CONTENTFUL_GRAPHQL_HOST: 'https://graphql.contentful.com',
    CONTENTFUL_ENVIRONMENT_ID: 'master',
    CONTENTFUL_SPACE_ID: 'ooioaq2tbzyk',
    LL_PRODUCER_API: 'https://lrs-main.learn-one-dev.autodesk.com/v1/producer',
    LL_CONSUMER_API: 'https://lrs-main.learn-one-dev.autodesk.com/v1/consumer',
    SHARE_PREFIX: 'https://app.upskill-stg.autodesk.com',
    LIST_API_HOST: 'https://lists-main.learn-one-stg.autodesk.com/api/v1',
    CLARUS_LINK: 'https://autodesk.clarus-stage.com',
    CERT_API:
      'https://jjsdqpcjfd.execute-api.us-west-1.amazonaws.com/convert-html-to-pdf',
    SEARCH_API: 'https://kp.services-stage.autodesk.com/community/service/rest/credential/v1/search',
    FILTER_API: 'https://kp.services-stage.autodesk.com/community/service/rest/credential/v1/filters',
    PKCE_CLIENT_ID: '4ty7y6VbGI1BGrHyrWHk5Wsf0VFgDAAY',
    PKCE_ENV: 'stg',
    PKCE_PROFILE_HOST: 'https://developer-stg.api.autodesk.com',
    ROUTER_BASENAME: '/learn',
    HTML_MAX_AGE: '86400',
    LEARN_LIVE_ENROLLMENT_HOST: 'https://main.learnlive-enrollment-api-dev.autodesk.com',
    LEARN_LIVE_COACHING_REQUEST_HOST: 'https://learnlive-coachingrequest-api-dev.autodesk.com',
    LEARN_LIVE_SERVICES_HOST: 'https://main.learn-live-services-stg.autodesk.com',
    CART_COUNT_URL: 'https://cart-api.ocstg.autodesk.com/v1/cart/count/{{cartId}}',
    FILEMANAGER_PROXY_HOST: 'false',
    FF_COACHING_REQUEST: 'true',
    LEARN_LIVE_COACHING_REQUEST_SUBMIT_VERSION: 'v2',
    COACHING_OVERVIEW_URL: 'https://www-pt.autodesk.com/coaching/overview',
    INVENTOR_CTA_BANNER_URL: 'https://www-pt.autodesk.com/products/inventor/overview',
    APP_ACCOUNTS: 'https://accounts.autodesk.com/',
    APP_PROFILE: 'https://profile.autodesk.com/',
    AUTHENTICATION_HOST: 'https://developer-stg.api.autodesk.com/authentication/v2/token',
    V3_LICENSE_API_HOST: 'https://api-stg.v3license.access.np.clic.autodesk.com/v1/licensable-features',
    VIDEO_LOCALIZATION_HOST: 'https://data-stg.beehive.autodesk.com/v1/get-video',
    UNIVERSAL_HEADER_CLIENT_APP: 'https://swc-stg.autodesk.com/web-mfe/universal-header/stage/v1/app.js',
    UNIVERSAL_FOOTER_CLIENT_APP: 'https://swc-stg.autodesk.com/web-mfe/universal-footer/stage/v1/app.js',
    USE_SSR_HNF: 'true',
    ADSK_LAUNCH_DARKLY_CLIENTSIDE_KEY: '5be4d121c69abc2fdb0ac124',
    SUCCESS_PLAN_URL: 'https://www-pt.autodesk.com/buying/plans',
    // CJS Web SDK Configuration
    CJS_ENABLED: 'true',
    FORGE_CLIENT_ID: '4ty7y6VbGI1BGrHyrWHk5Wsf0VFgDAAY', // Same as PKCE_CLIENT_ID for perf
    CJS_ENV: 'stg', // Use staging for perf environment
    CJS_EVENT_GENERATOR: 'learn-one-spa',
    CJS_AUTO_PAGE_CAPTURE: 'true',
    CJS_AUTO_LINK_CAPTURE: 'true',
    CJS_ADP_CDN: 'ase-cdn-stg',
    CJS_SWC_CDN: 'swc-stg',
  },
};

// Add ENVIRONMENT_CONSTANTS to AWS_ENV_VARS to allow for overrides
Object.keys(modExports.ENVIRONMENT_CONSTANTS.dev).forEach((key) => {
  modExports.AWS_ENV_VARS[key] = modExports.AWS_ENV_VARS[key] || {};
});

modExports.curatedSliceInitialState = {
  data: {},
  isLoaderVisible: true,
  isCongratsVisible: true,
  problemPassValue: 75,
};
modExports.curatedSliceName = 'curatedData';

modExports.tutorialSliceInitialState = {
  data: {},
  isLoaderVisible: true,
  problemPassValue: 75,
  isTutorialCompleted: false,
};
modExports.tutorialSliceName = 'tutorialData';

modExports.collectionSliceInitialState = {
  data: {},
  isLoaderVisible: false,
};
modExports.collectionSliceName = 'collectionData';

modExports.styleVariables = {
  background: lightTheme.tokens.colors.background,
  backgroundPanelColor: lightTheme.tokens.colors['background-panel'],
  inkOnBackground: lightTheme.tokens.colors['ink-on-background'],
  inkOnBackground60: lightTheme.tokens.colors['ink-on-background-60'],
  inkOnBackgroundDisabled: lightTheme.tokens.colors['ink-on-background-disabled'],
  inkSuccess: lightTheme.tokens.colors['ink-success'],
  fillWarning: lightTheme.tokens.colors['fill-warning'],
  divider: lightTheme.tokens.colors['ink-on-background-60'],
  lightDivider: lightTheme.tokens.colors['divider-0'],
  fontPrimary: lightTheme.tokens.typography['body-copy-medium'].fontFamily,
  fillSuccess: lightTheme.tokens.colors['fill-success'],
  fillSuccessSlight: lightTheme.tokens.colors['fill-success-slight'],
  fillError: lightTheme.tokens.colors['fill-error'],
  fillEngage: lightTheme.tokens.colors['fill-engage'],
  fillPrimary: lightTheme.tokens.colors['ink-on-fill-primary'],
  container0BoxShadow: lightTheme.tokens.effects['container-0'].boxShadow,
  detail1Opaque: lightTheme.tokens.colors['detail-1-opaque'],
  divider0BottomBoxShadow: lightTheme.tokens.effects['divider-0-bottom'].boxShadow,
  buttonOutlinedFocusBoxShadow: lightTheme.tokens.effects['focus-ring'].boxShadow,
  elevation0PopoverBoxShadow: lightTheme.tokens.effects['elevation-0-popover'].boxShadow,
};

modExports.catalogSliceInitialState = {
  path: {},
  result: {
    page: 1,
  },
  pagesShown: { tutorial: [1], curated: [1] },
  isLoaderVisible: true,
};
modExports.catalogSliceName = 'catalogData';

modExports.iconMap = {
  zip: FileZipIcon,
  doc: FileDocIcon,
  docx: FileDocIcon,
  pdf: FilePDFIcon,
  generic: FileGenericIcon,
};

modExports.LEARN_MFE = 'Learn MFE';

modExports.ADSK_LEGAL_NAME = 'ADSK';

// backend accepts 'systems' for IT coaching and 'product' for product coaching
modExports.COACHING_TYPES = {
  PRODUCT: 'product',
  SYSTEM: 'systems',
};

// Tab configuration for coaching catalog
modExports.COACHING_CATALOG_TABS = {
  PRODUCT_COACHING: {
    index: 0,
    keyword: 'product-coaching',
  },
  IT_COACHING: {
    index: 1,
    keyword: 'it-coaching',
  },
};

// Helper to get tab index from keyword
modExports.getTabIndexFromKeyword = (keyword) => {
  const { COACHING_CATALOG_TABS } = modExports;
  if (keyword === COACHING_CATALOG_TABS.PRODUCT_COACHING.keyword) return COACHING_CATALOG_TABS.PRODUCT_COACHING.index;
  if (keyword === COACHING_CATALOG_TABS.IT_COACHING.keyword) return COACHING_CATALOG_TABS.IT_COACHING.index;
  return null;
};

// Helper to get keyword from tab index
modExports.getKeywordFromTabIndex = (index) => {
  const { COACHING_CATALOG_TABS } = modExports;
  if (index === COACHING_CATALOG_TABS.PRODUCT_COACHING.index) return COACHING_CATALOG_TABS.PRODUCT_COACHING.keyword;
  if (index === COACHING_CATALOG_TABS.IT_COACHING.index) return COACHING_CATALOG_TABS.IT_COACHING.keyword;
  return null;
};

modExports.COACHING_CATALOG_ACTIVE_FILTERS = [
  'products',
  'industrySubSegments',
  'roles',
  'outcomes',
  'capabilities',
];

modExports.COACHING_CATALOG_FILTERS_LABEL_MAP = {
  products: 'Product',
  industrySubSegments: 'Industry',
  roles: 'Role',
  outcomes: 'Outcome',
  capabilities: 'Capability',
};

// Coaching type constants
modExports.coachTypeConstants = {
  ADMIN: 'ADMIN',
  SYSTEM: 'SYSTEM',
  PRODUCT: 'PRODUCT',
  FAST_TRACK: 'FASTTRACK',
};

// Coaching type key constants for fast track - TODO: typo issue in api response
modExports.COACHING_TYPE_KEY_FAST_TRACK = 'FASTRACK';
modExports.COACHING_TYPE_ID_FAST_TRACK = 5;

module.exports = modExports;
